import { Box, TextField, Button, CircularProgress } from "@mui/material";
import { Control, Controller, useWatch } from "react-hook-form";
import { ScheduleActionFormData } from "./types";

type TimeChangerProps = {
    control: Control<ScheduleActionFormData>;
    isUpdatingTimes: boolean;
    onUpdateTimes: () => void;
    onCancel: () => void;
};

export const TimeChanger = ({ control, isUpdatingTimes, onUpdateTimes, onCancel }: TimeChangerProps) => {
    const [newStartTime, newEndTime] = useWatch({
        control,
        name: ["newStartTime", "newEndTime"],
    });

    return (
        <Box p={2}>
            <Controller
                name="newStartTime"
                control={control}
                render={({ field }) => (
                    <TextField
                        {...field}
                        label="Horário de Início"
                        type="time"
                        size="small"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        sx={{ mb: 2 }}
                    />
                )}
            />
            <Controller
                name="newEndTime"
                control={control}
                render={({ field }) => (
                    <TextField
                        {...field}
                        label="Horário de Fim"
                        type="time"
                        size="small"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        sx={{ mb: 2 }}
                    />
                )}
            />
            <Button
                fullWidth
                variant="contained"
                size="small"
                onClick={onUpdateTimes}
                disabled={isUpdatingTimes || (!newStartTime && !newEndTime)}
                sx={{ mb: 1 }}
            >
                {isUpdatingTimes ? <CircularProgress size={16} sx={{ mr: 1 }} /> : null}
                Atualizar Horários
            </Button>
            <Button
                fullWidth
                color="secondary"
                size="small"
                onClick={onCancel}
            >
                Cancelar
            </Button>
        </Box>
    );
}; 